<template>
  <div class="input-group">
    <label class="input-group-text" for="selectOption">evaluate over</label>
    <select
      id="selectOption"
      class="form-select"
      v-model="evalOption"
      @change="optionChanged"
    >
      <option
        v-for="option of evalOptions"
        :key="option.id"
        :value="option.value"
      >
        {{ option.name }}
      </option>
    </select>
    <input
      v-if="evalOption === 'numWeeks'"
      v-model="numWeeks"
      class="form-control"
      type="number"
      placeholder="# weeks"
      min="1"
    />
    <input
      v-if="evalOption === 'dateRange'"
      v-model="dateStart"
      class="form-control"
      type="date"
      placeholder="start"
    />
    <span v-if="evalOption === 'dateRange'" class="input-group-text">-</span>
    <input
      v-if="evalOption === 'dateRange'"
      v-model="dateEnd"
      class="form-control"
      type="date"
      placeholder="end"
    />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
export default {
  name: 'evaluate-over',
  data() {
    return {
      evalOptions: [
        {
          id: 4,
          name: 'date range',
          value: 'dateRange',
        },
        {
          id: 0,
          name: 'past # weeks',
          value: 'numWeeks',
        },
        {
          id: 1,
          name: 'past 30 days',
          value: 'pastMonth',
        },
        {
          id: 2,
          name: 'past 90 days',
          value: 'pastQtr',
        },
        {
          id: 3,
          name: 'past year',
          value: 'pastYear',
        },
      ],
    }
  },
  emits: ['changed'],
  computed: {
    ...mapGetters('reporting', ['analysis']),
    evalOption: {
      get() {
        let _data = null
        if (this.analysis) {
          _data = this.analysis.evalOption
        }
        return _data
      },
      set(value) {
        this.setAnalysisData({
          name: 'evalOption',
          value: value,
        })
      },
    },
    numWeeks: {
      get() {
        let _data = null
        if (this.analysis) {
          _data = this.analysis.numWeeks
        }
        return _data
      },
      set(value) {
        this.setAnalysisData({
          name: 'numWeeks',
          value: value,
        })
      },
    },
    dateStart: {
      get() {
        let _data = null
        if (this.analysis) {
          _data = this.analysis.startDate
        }
        console.log('Start Date', _data)
        return _data
      },
      set(value) {
        this.setAnalysisData({
          name: 'startDate',
          value: value,
        })
      },
    },
    dateEnd: {
      get() {
        let _data = null
        if (this.analysis) {
          _data = this.analysis.endDate
        }
        console.log('End Date', _data)
        return _data
      },
      set(value) {
        this.setAnalysisData({
          name: 'endDate',
          value: value,
        })
      },
    },
  },
  methods: {
    ...mapActions('reporting', ['setAnalysisData']),
    optionChanged() {
      this.$emit('changed')
    },
  },
}
</script>
<style lang="scss" scoped>
</style>
